"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _reverse = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reverse"));
var _map2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/map"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _react = _interopRequireWildcard(require("react"));
var _immutable = _interopRequireDefault(require("immutable"));
var _jsWorkerSearch = _interopRequireDefault(require("js-worker-search"));
var _reactVirtual = require("@tanstack/react-virtual");
var _reselect = require("reselect");
var T = _interopRequireWildcard(require("prop-types"));
var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _Header = _interopRequireDefault(require("./Header"));
var _Row = _interopRequireWildcard(require("./Row"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "container": "dynamic_data_table-module__container___XBKGO",
  "table": "dynamic_data_table-module__table___KPe4Z",
  "header": "dynamic_data_table-module__header___InOJk",
  "hidden_scroll": "dynamic_data_table-module__hidden_scroll___smZMg",
  "cell": "dynamic_data_table-module__cell___WmECs",
  "title": "dynamic_data_table-module__title___xRq1r",
  "body": "dynamic_data_table-module__body____WpZz",
  "wrapper": "dynamic_data_table-module__wrapper___6vpz9",
  "inner": "dynamic_data_table-module__inner___DWRAj",
  "row": "dynamic_data_table-module__row___mJOCH",
  "even": "dynamic_data_table-module__even___s9yJX dynamic_data_table-module__row___mJOCH",
  "odd": "dynamic_data_table-module__odd___QReWF dynamic_data_table-module__row___mJOCH",
  "sortable": "dynamic_data_table-module__sortable___y8wPA",
  "no_wrap": "dynamic_data_table-module__no_wrap___hv7Wl",
  "custom_no_data": "dynamic_data_table-module__custom_no_data___qSxqC",
  "msg": "dynamic_data_table-module__msg___dAka6",
  "msg_icon": "dynamic_data_table-module__msg_icon___CBpqN",
  "no_rows": "dynamic_data_table-module__no_rows___DABRw dynamic_data_table-module__msg___dAka6",
  "fetching": "dynamic_data_table-module__fetching___Udqx5 dynamic_data_table-module__msg___dAka6",
  "ellipsis": "dynamic_data_table-module__ellipsis___GMwo_",
  "highlight": "dynamic_data_table-module__highlight___VP4U1",
  "actions": "dynamic_data_table-module__actions___geMKG",
  "tooltip": "dynamic_data_table-module__tooltip___iNmbQ",
  "copy": "dynamic_data_table-module__copy___ua22X"
};
const DEFAULT_ROW_HEIGHT = 48;
const DEFAULT_OVERSCAN = 15;
const getProcessedCollection = (0, _reselect.createSelector)([args => args.collection, args => args.columns, args => args.processors], (collection, columns, processors = {}) => {
  return (0, _map.default)(collection).call(collection, resource => {
    var _context;
    (0, _forEach.default)(_context = (0, _filter.default)(columns).call(columns, col => col.processors)).call(_context, col => {
      const ref = col.ref || {};
      const prop = ref.textProperty || ref.idProperty || col.property;
      const path = prop.split('.');
      let value = resource.getIn(path, '');
      for (let {
        func,
        args
      } of col.processors) {
        if (typeof value !== 'undefined' && typeof value[func] === 'function') {
          value = value[func](...args);
        } else if (typeof processors[func] === 'function') {
          value = processors[func]({
            ...args,
            value: value,
            rowData: resource
          });
        }
      }
      resource = resource.setIn(path, value);
    });
    return resource;
  });
});
const getFilteredList = (0, _reselect.createSelector)([args => args.collection, args => args.pkField, args => args.filteredIds], (collection, pkField, filteredIds) => {
  if (filteredIds) {
    return (0, _filter.default)(collection).call(collection, item => (0, _includes.default)(filteredIds).call(filteredIds, item.get(pkField))).toList();
  }
  return collection.toList();
});
const defaultSortFn = (a, b) => {
  // equal items sort equally
  if (a === b) {
    return 0;
  } else if (a === null || a === '') {
    // nulls/empty sort after anything else
    return 1;
  } else if (b === null || b === '') {
    return -1;
  }
  // default sort
  return a < b ? -1 : 1;
};
const getSortedList = (0, _reselect.createSelector)([args => args.collection, args => args.sortBy, args => args.sortDirection, args => args.sortDisabled, args => args.sortByFn], (collection, sortBy, sortDirection, sortDisabled, sortByFn) => {
  if (sortBy && sortDirection && !sortDisabled) {
    return collection.sortBy(item => item.get(sortBy, ''), sortByFn).update(collection => sortDirection === "down" ? (0, _reverse.default)(collection).call(collection) : collection).toList();
  }
  return collection.toList();
});
function buildSearchIndex(collection, columns, indexField) {
  // https://github.com/bvaughn/js-worker-search#custom-tokenizer-patterns
  // do not treat space, "-" and "/" as a delimiters
  const search = new _jsWorkerSearch.default({
    tokenizePattern: /[^a-z0-9-\s/]+/
  });
  const notIndexed = new _map2.default();
  const searchableColumns = (0, _filter.default)(columns).call(columns, col => col.searchable);
  (0, _forEach.default)(collection).call(collection, resource => {
    (0, _forEach.default)(searchableColumns).call(searchableColumns, col => {
      let ref = col.ref || {};
      let prop = ref.textProperty || ref.idProperty || col.property;
      let value = resource.getIn(prop.split('.'), '');
      if (typeof value !== 'object') {
        search.indexDocument(resource.get(indexField), value);
      } else {
        const prevValue = notIndexed.get(col.property);
        notIndexed.set(col.property, (prevValue || 0) + 1);
      }
    });
  });
  if (notIndexed.size) {
    for (let [key, num] of notIndexed) {
      /* eslint-disable no-console */
      console.warn(`Unable to index ${num} document(s) by column "${key}" \
          due to unsupported document type.`);
      /* eslint-enable no-console */
    }
  }

  return search;
}
const DynamicDataTable = props => {
  const parentRef = (0, _react.useRef)();
  const tooltipRef = (0, _react.useRef)();
  const searchRef = (0, _react.useRef)();
  const prevSortBy = (0, _react.useRef)();
  const searchDisabled = props.hasNextPage;
  const sortDisabled = props.hasNextPage;
  const [clientSearch, setClientSearch] = (0, _react.useState)();
  const [sortBy, setSortBy] = (0, _react.useState)(!sortDisabled ? props.sortBy : undefined);
  const [sortDirection, setSortDirection] = (0, _react.useState)(!sortDisabled ? props.sortDirection : undefined);
  const [sortedCollection, setSortedCollection] = (0, _react.useState)(_immutable.default.List());
  const [filteredCollection, setFilteredCollection] = (0, _react.useState)(_immutable.default.List());
  const [filteredIds, setFilteredIds] = (0, _react.useState)(null);
  const [searching, setSearching] = (0, _react.useState)(Boolean(props.searchText?.length));
  const rowVirtualizer = (0, _reactVirtual.useVirtualizer)({
    count: props.hasNextPage ? filteredCollection.size + 1 : filteredCollection.size,
    getScrollElement: () => parentRef.current,
    estimateSize: _react.default.useCallback(() => DEFAULT_ROW_HEIGHT, []),
    overscan: DEFAULT_OVERSCAN,
    parentRef
  });
  function updateFilter(collection) {
    if (props.searchText?.length) {
      performSearch(props.searchText);
      return;
    } else if (filteredIds?.length) {
      setFilteredIds(null);
    }
    setFilteredCollection(collection);
  }
  function performSearch(searchText) {
    if (!clientSearch) return;
    setSearching(true);
    const result = clientSearch.search(searchText).then(filteredIds => {
      const filteredList = getFilteredList({
        collection: sortedCollection,
        pkField: props.tablePkField,
        filteredIds
      });
      setFilteredIds(filteredIds);
      setFilteredCollection(filteredList);
    }).catch(error => {
      console.warn(error); /* eslint-disable-line no-console */
      throw error;
    });
    setSearching(false);
    if (typeof props.onSearch === 'function') {
      props.onSearch(result);
    }
    return result;
  }
  (0, _react.useEffect)(() => {
    if (!searchDisabled) {
      updateFilter(sortedCollection);
    }
  }, [props.searchText, props.hasNextPage, clientSearch]);
  (0, _react.useEffect)(() => {
    var _context2;
    if (sortDisabled) {
      return;
    }
    let column = (0, _find.default)(_context2 = props.columns).call(_context2, column => column.property === sortBy);
    const sortByFn = props.customSort?.[column?.sortFn] ?? defaultSortFn;
    let filteredList;
    if (prevSortBy?.current === sortBy && filteredCollection.size) {
      filteredList = (0, _reverse.default)(filteredCollection).call(filteredCollection);
    } else {
      filteredList = getSortedList({
        collection: filteredCollection,
        sortBy: sortBy,
        sortDirection: sortDirection,
        sortDisabled: sortDisabled,
        sortByFn: sortByFn
      });
      prevSortBy.current = sortBy;
    }
    setFilteredCollection(filteredList);
    const sortedList = getSortedList({
      collection: props.data,
      sortBy: sortBy,
      sortDirection: sortDirection,
      sortDisabled: sortDisabled,
      sortByFn: sortByFn
    });
    setSortedCollection(sortedList);
  }, [sortBy, sortDirection]);
  (0, _react.useEffect)(() => {
    const processedCollection = getProcessedCollection({
      collection: props.data,
      columns: props.columns,
      processors: props.processors
    });
    const sortedList = getSortedList({
      collection: processedCollection,
      sortBy: sortBy,
      sortDirection: sortDirection,
      sortDisabled: sortDisabled,
      sortByFn: props.customSort?.[props.columns[sortBy]?.sortFn] ?? defaultSortFn
    });
    setSortedCollection(sortedList);
    if (searchDisabled) {
      setFilteredCollection(sortedList);
    } else {
      if (searchRef.current) {
        searchRef.current.terminate();
      }
      const _clientSearch = buildSearchIndex(processedCollection, props.columns, props.tablePkField);
      searchRef.current = _clientSearch;
      setClientSearch(_clientSearch);
    }
  }, [props.data, props.hasNextPage]);
  (0, _react.useEffect)(() => {
    var _context3;
    const [lastItem] = (0, _reverse.default)(_context3 = [...rowVirtualizer.getVirtualItems()]).call(_context3);
    if (!lastItem) {
      return;
    }
    if (lastItem.index >= props.data.size - 1 && props.hasNextPage && !props.isFetchingNextPage) {
      props.fetchNextPage();
    }
  }, [props.hasNextPage, props.fetchNextPage, props.data, props.isFetchingNextPage, rowVirtualizer.getVirtualItems()]);
  (0, _react.useEffect)(() => {
    return function cleanup() {
      if (searchRef.current) {
        searchRef.current.terminate();
      }
    };
  }, []);
  const rowItems = rowVirtualizer.getVirtualItems();
  const hasNoData = !filteredCollection.size && !props.isFetchingNextPage && !props.hasNextPage;
  const handleSortUpdate = (0, _react.useCallback)((newSortBy, newSortDirection) => {
    setSortBy(newSortBy);
    setSortDirection(newSortDirection);
  }, [sortBy, sortDirection]);
  const sortProps = {
    onClick: handleSortUpdate,
    sortDisabled,
    sortBy,
    sortDirection
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.table
  }, /*#__PURE__*/_react.default.createElement(_Header.default, (0, _extends2.default)({}, sortProps, {
    columns: props.columns
  })), /*#__PURE__*/_react.default.createElement("div", {
    ref: parentRef,
    className: styles.body
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.wrapper,
    style: {
      height: rowVirtualizer.getTotalSize()
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-offsety": rowItems[0]?.start ?? 0,
    style: {
      transform: `translateY(${rowItems[0]?.start ?? 0}px)`
    },
    className: styles.inner
  }, (0, _map.default)(rowItems).call(rowItems, virtualRow => {
    const isLoaderRow = virtualRow.index > filteredCollection.size - 1;
    if (isLoaderRow) {
      if (props.hasNextPage || props.isFetchingNextPage) {
        return /*#__PURE__*/_react.default.createElement(_Row.LoaderRow, {
          key: "row_loader"
        });
      }
      return;
    }
    return /*#__PURE__*/_react.default.createElement(_Row.default, {
      key: virtualRow.key,
      rowRef: rowVirtualizer.measureElement,
      index: virtualRow.index,
      columns: props.columns,
      data: filteredCollection.get(virtualRow.index),
      searchText: props.searchText,
      tooltipRef: tooltipRef.current,
      formatters: props.formatters,
      timezone: props.timezone
    });
  }), hasNoData && /*#__PURE__*/_react.default.createElement(_Row.NoMoreDataRow, {
    customNoData: props.customNoData
  })), /*#__PURE__*/_react.default.createElement("div", {
    ref: tooltipRef
  })))));
};
DynamicDataTable.propTypes = {
  columns: T.arrayOf(T.object),
  data: T.oneOfType([_reactImmutableProptypes.default.list, (0, _map.default)(_reactImmutableProptypes.default)]).isRequired,
  sortBy: T.string,
  sortDirection: T.oneOf(['up', 'down']),
  searchEnabled: T.bool,
  searchText: T.string,
  hasNextPage: T.bool,
  fetchNextPage: T.func,
  isFetchingNextPage: T.bool,
  processors: T.object,
  sortByFn: T.func,
  timezone: T.string
};
DynamicDataTable.defaultProps = {
  sortDirection: 'up',
  processors: {},
  timezone: _momentTimezone.default.tz.guess()
};
var _default = exports.default = DynamicDataTable;